<template>
    <BaseDialog
        :showDialog="showSearchDialog"
        maxDialogWidth="1500"
        maxCardHeight="700"
        :scrollable="true"
        headline="lang_CONTRACTS_PUBLISHING_ADD_WORKS_DIALOG_TITLE"
        :close="closeDialog"
        :alvqa="alvqa"
    >    
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row>
                    <v-col cols="11">
                        <SearchFilter 
                            :context="searchcontext" 
                            @keydown.enter="searchForListItems"
                            :alvqa="alvqa + '-textfield-search'"
                        />
                    </v-col>
                    <v-col align-self="end" class="text-right">
                        <BaseIcon 
                            @click="searchForListItems" 
                            icon="fa-search" 
                            tooltipText="lang_GENERIC_CAPTION_SEARCH"
                            :alvqa="alvqa + '-button-search'"
                        />
                    </v-col>
                </v-row>
        <!-- IF found items are over 100! -->
                <v-row v-if="showBiggerResults" class="pb-3">
                    <v-col>
                        <BaseHeaderStats 
                            typeStats="LIST"
                            :alvqa="alvqa"
                            :context="searchcontext"
                            :specificSelected="searchResult.filteredRecords"
                        />
                    </v-col>
                </v-row>
                <v-row v-if="showSearchResult" class="pb-3">
                    <v-col 
                        v-if="items.length !== 0"
                        class="pl-7"
                    >
                        <!--  CHECKBOX TO SELECT ALL ITEMS -->
                        <v-checkbox
                            :alvqa="alvqa + '-checkbox-all-select'"
                            v-model="allSelected"
                            @click.stop="selectAll"
                            hide-details
                            color="generalCheckbox"
                            :disabled="disabledAllSelect"
                        >
                            <template v-slot:label>
                                <BaseHeaderStats 
                                    :context="searchcontext" 
                                    typeStats="DIALOG"
                                    :alvqa="alvqa"
                                    useContextForTotal="SearchDialog"
                                />
                            </template>
                        </v-checkbox>
                    </v-col>
                    <v-col 
                        v-else
                        :alvqa="alvqa + '-text-none-found'"
                    >
                    0 {{ $t('lang_GENERAL_CAPTION_FOUND') }}
                    </v-col>
                </v-row>  
                <v-divider v-if="items.length > 0"></v-divider>    
                <v-list two-line>
                    <v-list-item-group
                        v-model="selected"
                        multiple
                        @change="checkSelectAll()"
                    >
                        <v-list-item
                            v-for="(item, i) in items"
                            :key="item.alvId"
                            :value="i"
                            @click="selectItem(item.alvId, i)"
                            :disabled="showBiggerResults ? false : item.alvInternalDisable"
                            :alvqa="alvqa + '-result-list-row-' + item.alvId"
                        >
                            <template v-slot:default="{ active }">
                                <v-list-item-action 
                                    v-if="!showBiggerResults"
                                    class="mr-2"
                                >
                                    <!--  CHECKBOX TO SELECT A SPECIFIC ITEM -->
                                    <v-checkbox
                                        :input-value="active"
                                        color="generalCheckbox"
                                        hide-details
                                        :disabled="item.alvInternalDisable"
                                        :alvqa="alvqa + '-result-list-row-' + item.alvId + '-checkbox'"
                                    ></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title :alvqa="alvqa + '-result-list-row-' + item.alvId + '-title'">
                                        {{ item.title}} {{ item.gemaNumber ? '(' + item.gemaNumber + ')' : '' }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle 
                                        :alvqa="alvqa + '-result-list-row-' + item.alvId + '-subtitle'"
                                        style="white-space: normal;"
                                    >
                                        {{ 
                                            item.interestedParties.map(element => {
                                                return element.name + ' (' + element.role + ')'
                                            }).join(", ")
                                        }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>  
            </v-container>
        </template>
        
        <template v-slot:dialogActions>
            <v-container fluid>
                <v-row>
                    <v-spacer />
                    <v-col class="text-right">
                        <BaseButton 
                            v-if="!showBiggerResults"
                            :disabled="!selected.length" 
                            @click="add()"
                            label="lang_CONTRACTS_PUBLISHING_ADD_WORKS_DIALOG_BUTTON_ADD_WORKS"
                            :alvqa="alvqa +  '-button-add'"
                        />
                        <BaseButton 
                            v-if="showBiggerResults"
                            @click="add()"
                            label="lang_GENERIC_CAPTION_ASSIGN_ALL"
                            :alvqa="alvqa +  '-button-assign-all'"
                        />
                    </v-col>
                </v-row>
            </v-container>        
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'

import SearchFilter from '@/components/_filters/SearchFilter'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'

export default {
    name: "PublishingContractsSubCataloguesWorksEditPanelDialog",
    components: {
        BaseDialog,
        SearchFilter,
        BaseIcon,
        BaseButton,
        BaseHeaderStats
    },
    data() {
        return {
            showSearchResult: false,   
            items: [],
            selected: [], // selected Checkboxes
            allSelected: false,
            disabledAllSelect: false,
            showBiggerResults: false,
            searchResult: null,
            searchId: null,
            context: "PublishingContractsSubcatalogues",
            alvqa: 'contracts-publishing-edit-form-add-sub-catalogues-works-dialog',
            searchcontext: 'WorksForSubCatalogues',
        }
    },
    computed: {
        showSearchDialog: {
            get() { return this.$store.getters.getShowSearchSubCataloguesWorksDialog },
            set(show) { this.$store.commit('setShowSearchSubCataloguesWorksDialog', show) }
        },
        selectedItemIds: { // selected items for add function
            get() { return this.$store.getters['getSelected' + this.searchcontext] },
            set(selected) { this.$store.commit('setSelected' + this.searchcontext, selected) }
        }
    },
    methods: {
        async searchForListItems() {
            this.$store.commit('setIsLoading', true)
            if(this.$store.getters['get' + this.searchcontext + 'Search']) {
                this.selectedItemIds = []
                this.selected = []
                this.allSelected = false

                this.searchResult = await this.$store.dispatch('search' + this. searchcontext)
                if(this.searchResult.filteredRecords <= 100) {
                    this.showBiggerResults = false
                    this.showSearchResult = true
                } else {
                    this.showBiggerResults = true
                    this.searchId = this.searchResult.searchId
                    this.$alvPlugin.storePagingInformations(this.searchResult.filteredRecords, this.searchResult.currentPage, this.searchResult.totalRecords)
                }
                this.items = this.searchResult.list
            }

            if(!this.$store.getters['get' + this.searchcontext + 'Search']) this.items = []

            // disable 'selectAll' checkbox if all rows are already added, only when length of the found items is <= 100
            if(this.searchResult.filteredRecords <= 100) { 
                let selectable = this.items.reduce((num, item) => num + Number(!item.alvInternalDisable), 0)
                this.disabledAllSelect = selectable == 0

                this.$store.commit('setTotalListedSearchDialog', selectable)
                this.$store.commit('setTotalRecordsSearchDialog', this.items.length)
            }
            
            this.$store.commit('setIsLoading', false)
        },
        async add() {     
            let selectedItems = []
            for(let i = 0; i < this.selected.length; i++) {
                selectedItems.push(this.items[this.selected[i]]) // to add the full items in frontend data table
            }

            await this.$store.dispatch('addWorksToSubCatalogue', { searchId: this.searchId}) 
            this.searchForListItems()
        },
        selectAll() {
            if(this.allSelected == true) {
                this.selected = []
                this.selectedItemIds = []
                for(let i = 0; i < this.items.length; i++) {
                    if( this.items[i].alvInternalDisable != true ){
                        this.selected.push(i)
                        this.selectedItemIds.push(this.items[i].alvId)
                    }
                }
            } else {
                this.selected = []
                this.selectedItemIds = []
                this.allSelected = false
            }
        },
        checkSelectAll(){
            let selectable = this.items.reduce((num, item) => num + Number(!item.alvInternalDisable), 0)

            if(this.selected.length === this.items.length || (selectable > 0 && selectable === this.selected.length)) 
                this.allSelected = true
            else 
                this.allSelected = false
        },
        selectItem(alvId, rowId) {  
            let indexOfItem = this.selected.indexOf(rowId)            
            if(indexOfItem >= 0) {
                this.selectedItemIds.splice(this.items[rowId].alvId, 1)
            }
            else {
                this.selectedItemIds.push(this.items[rowId].alvId)
            }
        },
        closeDialog() {
            this.showSearchDialog = false
            this.selectedItemIds = []
            this.selected = []
            this.items = []
            this.allSelected = false
            this.showSearchResult = false
            this.showBiggerResults = false
            this.searchId = null
            this.$store.commit('set' + this.searchcontext + 'Search', '')
            this.disabledAllSelect = false
            this.$store.commit('setTotalListedSearchDialog', 0)
            this.$store.commit('setTotalRecordsSearchDialog', 0)
            this.$store.commit('setSelectedPublishingContractsSubCatalogues', [])
        }
    }
}
</script>